import { render } from "./Video.vue?vue&type=template&id=2f921ca4&scoped=true"
import script from "./Video.vue?vue&type=script&lang=js"
export * from "./Video.vue?vue&type=script&lang=js"

import "./Video.vue?vue&type=style&index=0&id=2f921ca4&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f921ca4"]])

export default __exports__